import { type FC } from 'react';
import { HStack, Image, LineBreak, Text, VStack } from '@direct-frontend/components';
import Party from '@direct-frontend/components/src/icons/illustrated/Character/CharacterParty.svg';
import styles from './DashboardTodoListAllCompletedBanner.module.css';

export const DashboardTodoListAllCompletedBanner: FC = () => (
    <HStack gap="20" className={styles.root} data-testid="DashboardTodoList.AllCompletedBanner">
        <Image height="72px" width="72px" src={Party} alt="Отличная работа!" />{' '}
        <VStack>
            <Text bold size="m">
                Отличная работа!
            </Text>
            <Text size="m" role="supplementary" color="gray">
                Вы выполнили все текущие рекомендации.
                <LineBreak mode="compact" />
                Пока новых нет, но мы уже готовим следующие и скоро покажем их здесь.
            </Text>
        </VStack>
    </HStack>
);
